<app-unified-header [title]="!macId ? 'Add Device' : isReadMode ? 'Device Details' : 'Edit Device'"
  (onSave)="manageDevice()" defaultHref="/device-list" [restrictBack]="deviceDetailsForm && !deviceDetailsForm.pristine"
  [saveBtn]="{title: macId && isReadMode ? 'Edit' : 'Save', isDisable: macId && isReadMode ? false : isSaveDisabled, rule: macId ? 'putDevice' : ''}"
  [isRootPage]="isRootPage"></app-unified-header>

<ion-content *ngIf="deviceDetailsForm">
  <ion-label class="section-header" *ngIf="mode === 'add'">Please provision the device before adding the device to the
    facility.</ion-label>
  <div class="section-label">Device Information</div>
  <form [formGroup]="deviceDetailsForm">
    <ion-item class="form-item-detail" [ngClass]="{'interactive': !isReadMode}">
      <ion-label>Service Provider</ion-label>
      <ion-text slot="end">{{serviceName}}</ion-text>
    </ion-item>
    <ng-container *ngFor="let config of deviceDetailsInputConfig">
      <unified-input ngDefaultControl [formControlName]="config.name || null" [config]="getConfig(config)"
        (changed)="inputChanged($event)" [formData]="deviceDetailsForm.value"></unified-input>
    </ng-container>
    <ion-item class="form-item-detail" [detail]="!isReadMode || !macId"
      [ngClass]="{'interactive': !isReadMode || !macId}" (click)="setDeviceType()">
      <ion-label>Model/Type</ion-label>
      <ion-text slot="end">{{f['modelName']?.value}}</ion-text>
    </ion-item>
    <ng-container *ngIf="f['modelName']?.value">
      <ion-item *ngIf="!isReadMode || !macId">
        <ion-label class="select-label">Placement</ion-label>
        <ion-select slot="end" aria-label="Choose" placeholder="Choose" formControlName="placementType"
          interface="popover">
          <ion-select-option *ngFor="let pd of placementTypes" [value]="pd.name">{{pd.displayName}}</ion-select-option>
        </ion-select>
      </ion-item>
      <ion-item *ngIf="macId && isReadMode" class="form-item-detail" detail="false" [ngClass]="{'interactive': false}">
        <ion-label>Placement</ion-label>
        <ion-text slot="end">{{f['placementTypeName']?.value || 'Unassigned'}}</ion-text>
      </ion-item>
    </ng-container>

    <ng-container *ngIf="f['placementType']?.value">
      <ng-container *ngIf="f['placementType']?.value === 'bedslot'">
        <ion-item class="form-item-detail first-item-border" [detail]="!isReadMode || !macId"
          [ngClass]="{'interactive': !isReadMode}" (click)="setRoom()">
          <ion-label>Room</ion-label>
          <ion-text slot="end" [class.app-link]="f['roomName']?.value && isReadMode && macId"
            [class.no-link]="!isRoomSummaryEnabled" [class.none-value]="!f['roomName']?.value">{{f['roomName']?.value ||
            (isReadMode ? 'Unassigned' : 'None')}}<span
              *ngIf="macId && isReadMode && f['roomName']?.value && f['slotName']?.value && isBedSlotEnabled">-{{
              f['slotName']?.value
              }}</span></ion-text>
        </ion-item>
        <ion-item class="form-item-detail indent-item-detail" [detail]="!isReadMode || !macId"
          [ngClass]="{'interactive': !isReadMode}" (click)="setBedSlot()" [disabled]="!f['roomName']?.value"
          *ngIf="isBedSlotEnabled && (!isReadMode || !macId)">
          <ion-label>Bed Slot</ion-label>
          <ion-text slot="end" [class.app-link]="f['slotName']?.value && isReadMode && macId"
            [class.no-link]="!isRoomSummaryEnabled" [class.none-value]="!f['slotName']?.value">{{f['slotName']?.value ||
            'None'}}</ion-text>
        </ion-item>
      </ng-container>
      <ng-container *ngIf="f['placementType']?.value === 'bed'">
        <ion-item class="form-item-detail" [detail]="!isReadMode || !macId" [ngClass]="{'interactive': !isReadMode}"
          (click)="setBed()">
          <ion-label>Bed</ion-label>
          <ion-text slot="end" [class.app-link]="f['bedName']?.value && isReadMode && macId"
            [class.none-value]="!f['bedName']?.value">{{f['bedName']?.value ||
            (isReadMode ? 'Unassigned' : 'None')}}</ion-text>
        </ion-item>
      </ng-container>
      <ion-item class="form-item-detail" detail="false" [ngClass]="{'interactive': false}" (click)="setResident()"
        *ngIf="isReadMode && macId">
        <ion-label>Resident</ion-label>
        <ion-text slot="end" [class.app-link]="f['residentName']?.value && isReadMode"
          [class.no-link]="!isWearerSummaryEnabled"
          [class.none-value]="!f['residentName']?.value">{{f['residentName']?.value || 'Unassigned'}}</ion-text>
      </ion-item>
    </ng-container>
  </form>
  <div class="delete-device" *ngIf="macId && isReadMode">
    <ion-button color="danger" (click)="deleteDevice()" [nAccess]="'deleteDevice'">Delete This Device</ion-button>
  </div>
</ion-content>